import orderBy from 'lodash/orderBy';

const dataSort = (fields, data, sortFields, sortOrders) => {
    if (!Array.isArray(fields) || !Array.isArray(data) || !Array.isArray(sortFields) || !Array.isArray(sortOrders)) {
        throw new Error('Invalid sort parameters, need to be Arrays');
    }

    if (sortFields.find(sortField => !fields.includes(sortField))) {
        throw new Error('Sort Fields contain fields not present in the data');
    }

    const dataObjs = data.map(row => fields.reduce((rowObj, field, index) => {
        rowObj[field] = row[index];
        return rowObj;
    }, {}));

    const sortedDataObjs = orderBy(dataObjs, sortFields, sortOrders);
    return sortedDataObjs.map(dataObj => fields.reduce((dataItem, field) => [...dataItem, dataObj[field]], []));
};

export default dataSort;